import { DocumentServicesObject } from '@wix/document-services-types';

import { createPluginHostApi } from './pluginHostAPI';
import { PluginService } from './pluginService';
import { SlotsService } from './slotsService';

import { IExperimentsApiAdapter } from '../../utils/experimentsApiAdapter';
import { HeaderPluginService } from './headerPluginService';
import { createHeaderPluginsApi } from './headerPluginsAPI';

export function initPluginsServices(
  documentServicesAPI: DocumentServicesObject,
  experimentsAPI: IExperimentsApiAdapter,
) {
  const hostAPI = createPluginHostApi(documentServicesAPI, experimentsAPI);
  const headerPluginHostApi = createHeaderPluginsApi(
    documentServicesAPI,
    experimentsAPI,
  );

  return {
    headerPlugins: new HeaderPluginService(headerPluginHostApi),
    plugins: new PluginService(hostAPI),
    slots: new SlotsService(hostAPI),
  };
}
